import { render, staticRenderFns } from "./KybPage.vue?vue&type=template&id=8ec7d3f2"
import script from "./KybPage.vue?vue&type=script&lang=js"
export * from "./KybPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports